import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LayerBackendService } from 'src/app/shared/services/layer-backend.service';

import { FarmSettings, UpsertFarmSettingsResponse } from '../models/farm-settings.model';

@Injectable({
  providedIn: 'root',
})
export class FarmSettingsService {
  protected get baseUrl(): string {
    return this.backend.sustainabilityBaseUrl;
  }

  constructor(
    protected http: HttpClient,
    private readonly backend: LayerBackendService,
  ) {}

  getFarmSettings(): Observable<FarmSettings | HttpErrorResponse> {
    return this.http.get<FarmSettings>(`${this.baseUrl}/farm-settings`).pipe(
      map((farmSettings) => farmSettings),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of({ enableCO2Calculation: false } as FarmSettings);
        } else {
          return throwError(() => new Error(error.message));
        }
      }),
    );
  }

  upsertFarmSettings(
    farmSettings: FarmSettings,
  ): Observable<UpsertFarmSettingsResponse | HttpErrorResponse> {
    return this.http
      .post<UpsertFarmSettingsResponse>(`${this.baseUrl}/farm-settings`, farmSettings, {})
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => new Error(error.message))));
  }
}
